import { Card, CardBody, Col, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { CheckBoxButtonGroups } from "../../../../Constant";
import { DynamicCheckBoxButtonGroup } from "./DynamicCheckBoxButtonGroup";
import { StaticCheckBoxButtonGroup } from "./StaticCheckBoxButtonGroup";
import { CHECKBOX_BUTTON_GROUP } from "../../../../Data/Buttons/ButtonGroup";

const CheckBoxButtonGroup = () => {
  return (
    <Col sm="12">
      <Card>
        <CommonCardHeader title={CheckBoxButtonGroups} span={CHECKBOX_BUTTON_GROUP} />
        <CardBody className="btn-group-showcase">
          <Row>
            <StaticCheckBoxButtonGroup />
            <DynamicCheckBoxButtonGroup />
          </Row>
        </CardBody>
      </Card>
    </Col>
  )
}

export default CheckBoxButtonGroup